'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00242 from "./presto.-Agent-View$$anon$2.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00244 from "./presto.-Agent-View$$anon$4.js";
import * as $j_presto$002etypes$0024proto$0024$002dAvailable$002dCredentials$0024 from "./presto.types$proto$-Available-Credentials$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$1(outer) {
  this.avx = null;
  this.avp = null;
  this.avq = false;
  this.avy = null;
  this.avz = false;
  this.avC = null;
  this.avv = null;
  this.avw = false;
  this.avr = null;
  this.avs = false;
  this.avt = null;
  this.avu = false;
  this.avA = false;
  this.avB = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.avx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.avC = "AvailableCredentials";
}
export { $c_Lpresto_AgentView$$anon$1 as $c_Lpresto_AgentView$$anon$1 };
$p = $c_Lpresto_AgentView$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$1;
/** @constructor */
function $h_Lpresto_AgentView$$anon$1() {
}
export { $h_Lpresto_AgentView$$anon$1 as $h_Lpresto_AgentView$$anon$1 };
$h_Lpresto_AgentView$$anon$1.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.avx;
});
$p.L = (function() {
  if ((!this.avq)) {
    this.avp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.avq = true;
  }
  return this.avp;
});
$p.O = (function() {
  if ((!this.avz)) {
    this.avy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.avz = true;
  }
  return this.avy;
});
$p.E = (function() {
  return this.avC;
});
$p.t = (function() {
  if ((!this.avw)) {
    this.avv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("policy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.avw = true;
  }
  return this.avv;
});
$p.M = (function() {
  if ((!this.avs)) {
    this.avr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dAgent$002dView$0024$0024anon$00242.$c_Lpresto_AgentView$$anon$2())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.avs = true;
  }
  return this.avr;
});
$p.Q = (function() {
  if ((!this.avu)) {
    this.avt = new $j_presto$002e$002dAgent$002dView$0024$0024anon$00244.$c_Lpresto_AgentView$$anon$4();
    this.avu = true;
  }
  return this.avt;
});
$p.w = (function() {
  if ((!this.avB)) {
    this.avA = false;
    this.avB = true;
  }
  return this.avA;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee39) => ((p) => \u03b4scrutinee39.cGE(p)))($j_presto$002etypes$0024proto$0024$002dAvailable$002dCredentials$0024.$m_Lpresto_types$proto$AvailableCredentials$())));
});
var $d_Lpresto_AgentView$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$1, "presto.AgentView$$anon$1", ({
  Dx: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$1 as $d_Lpresto_AgentView$$anon$1 };
//# sourceMappingURL=presto.-Agent-View$$anon$1.js.map
